module.exports = __webpack_public_path__ + "static/media/distribuicao-banner.19ee81fe.jpg";